<template>
  <div class="zoomable" ref="wrap" @wheel="onWheel">
    <div class="zoomable__inner" :style="innerStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Zoomable',
  data() {
    return {
      scale: 1,
    };
  },
  computed: {
    innerStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'center center',
      };
    },
  },
  methods: {
    onWheel(e) {
      if (!e.ctrlKey && !e.metaKey) {
        return;
      }
      e.preventDefault();
      const delta = e.deltaY > 0 ? -0.12 : 0.12;
      this.scale = Math.min(4, Math.max(0.25, this.scale + delta));
    },
  },
};
</script>

<style scoped>
.zoomable {
  overflow: auto;
  max-height: 75vh;
  max-width: 100%;
  text-align: center;
}

.zoomable__inner {
  display: inline-block;
}
</style>
